import React, { useState, useEffect, useMemo } from "react";
import ReactDOMServer from 'react-dom/server';
import classNames from "classnames";
import { statusClass } from "./utils";
import _ from 'lodash';

function ListBox(props) {

  const idField = props.idField || 'id';

  const [localCollapsed, setLocalCollapsed] = useState(false);
  const [filterText, setFilterText] = useState('');
  const [localCatalog, setLocalCatalog] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]);

  // only used in table mode
  const [sortCol, setSortCol] = useState(null);
  const [sortDirectionAsc, setSortDirectionAsc] = useState(true);

  useEffect(() => {
    setLocalCatalog(Array.from(props.catalog));
  }, [props.catalog])

  useEffect(() => {
    if (!sortCol) {
      setLocalCatalog(Array.from(props.catalog));
      return;
    }

    let sortedCatalog = _.sortBy(
      props.catalog,
      [c => _.find(c.title, tobj => tobj.column === sortCol).value]);

    if (!sortDirectionAsc) {
      _.reverse(sortedCatalog);
    }

    setLocalCatalog(sortedCatalog);
  }, [props.catalog, sortCol, sortDirectionAsc])

  const toggleLocalCollapse = () => {
    setLocalCollapsed(!localCollapsed);
  }

  const onFilterChanged = (e) => {
    props.onFilterChanged(e.target.value);
    //setFilterText(e.target.value);
  }

  const onTableHeaderClick = (e, value, index) => {
    if (sortCol === value.column) {
      if (sortDirectionAsc) {
        setSortDirectionAsc(false);
      } else {
        setSortCol(null);
        setSortDirectionAsc(true);
      }
    } else {
      setSortCol(value.column);
      setSortDirectionAsc(true);
    }
  }

  const onExpandClick = (e, index) => {
    let localExpandedRows = Array.from(expandedRows);
    if (localExpandedRows.indexOf(index) === -1) {
      localExpandedRows.push(index);
    } else {
      _.pull(localExpandedRows, index);
    }

    setExpandedRows(localExpandedRows);

    //e.preventDefault();
    e.stopPropagation();
  }

  const hasExpand = useMemo(() => {
    return _.some(_.map(props.catalogTableColumns || [], 'expand'));
  }, [props.catalogTableColumns])

  // make refs for scrolling - only used when catalogTableHeight set
  const refs = props.catalog.reduce((acc, value) => {
    acc[value.key] = React.createRef();
    return acc;
  }, {})

  useEffect(() => {
    // SCROLL IT
    if (props.selectedIds.length > 0 && props.catalogTableHeight) {
      if (refs.hasOwnProperty(props.selectedIds[0])) {
        refs[props.selectedIds[0]].current.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
    }
  }, [props.selectedIds, props.catalogTableHeight]);

  return (
    <div
      className={classNames("list-box-panel", "panel", "panel-default", {
        "box-collapsed": localCollapsed || props.selected,
      })}
    >
      <div className="panel-heading">
        <h4 className="panel-title">
          {props.title} <span className="badge">{props.catalog.length}</span>
          {props.showFilter && (
            <div
              className={classNames("btn-group", {
                invisible: !!props.selected || props.catalogTable,
              })}
            >
              <input
                type="search"
                className="form-control input-sm"
                placeholder="Filter"
                id="list-box-filter"
                onChange={onFilterChanged}
                value={props.filterText}
              />
              <span
                id="searchclear"
                className="glyphicon glyphicon-remove-circle"
                onClick={(e) => {
                  // props.filterText = "";
                  onFilterChanged({ ...e, target: { ...e.target, value: "" } });
                }}
              ></span>
            </div>
          )}
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={toggleLocalCollapse}
          >
            <span
              aria-hidden="true"
              className={classNames(
                "glyphicon",
                { "glyphicon-collapse-up": !localCollapsed },
                { "glyphicon-collapse-down": localCollapsed },
                { hidden: !!props.selected || props.catalogTable }
              )}
            ></span>
          </button>
        </h4>
      </div>

      {!props.catalogTable && (
        <div className="list-group">
          {props.catalog.map((value, index) => {
            return (
              <a
                href="#"
                key={index}
                className={classNames("list-group-item", {
                  "list-group-item-info":
                    props.hovered &&
                    props.hovered.length &&
                    props.hovered.indexOf(value[idField]) !== -1,
                })}
                onClick={(e) => props.onListItemClick(value, e)}
                onMouseOver={(e) => props.onListItemMouseOver(value, e)}
                onMouseOut={(e) => props.onListItemMouseOut(value, e)}
              >
                {value.title}
              </a>
            );
          })}
        </div>
      )}

      {props.catalogTable && (
        <table className={classNames("table", props.catalogTableClasses)}>
          <colgroup>
            {props.catalogTableColumns.map((value, index) => {
              return (
                <col key={index} className={`catalog-col-${value.column}`} />
              );
            })}
          </colgroup>
          <thead>
            <tr>
              <th
                colSpan={props.catalogTableColumns.length}
                className="listbox-filter-row"
              >
                <div className="input-group">
                  <div className="input-group-addon">
                    <span
                      className="glyphicon glyphicon-search"
                      aria-hidden="true"
                    ></span>
                  </div>
                  <input
                    type="text"
                    className="form-control input-sm"
                    placeholder="Filter"
                    id="list-box-filter"
                    onChange={onFilterChanged}
                    value={props.filterText}
                  />
                </div>
              </th>
            </tr>
            <tr>
              {props.catalogTableColumns.map((value, index) => {
                return (
                  <th
                    key={index}
                    className={classNames(`catalog-col-${value.column}`, {
                      hidden: value.expand,
                    })}
                    onClick={(e) =>
                      value.sortable !== false &&
                      onTableHeaderClick(e, value, index)
                    }
                    data-sortable={value.sortable !== false}
                  >
                    {value.label}
                    <span
                      className={classNames(
                        "glyphicon",
                        {
                          "glyphicon-triangle-top":
                            sortCol !== null && sortDirectionAsc,
                        },
                        {
                          "glyphicon-triangle-bottom":
                            sortCol !== null && !sortDirectionAsc,
                        },
                        { hidden: value.column !== sortCol }
                      )}
                    ></span>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody
            className={classNames({
              "catalog-table-fixed-height": !!props.catalogTableHeight,
            })}
            style={{
              height: props.catalogTableHeight
                ? `${props.catalogTableHeight}px`
                : "",
            }}
          >
            {localCatalog.map((value, index) => {
              let isHidden = !(
                expandedRows.indexOf(value.key) !== -1 ||
                (props.selectedIds &&
                  props.selectedIds.indexOf(value.key) !== -1)
              );

              return (
                <tr
                  key={value.key}
                  ref={refs[value.key]}
                  onClick={(e) => props.onListItemClick(value, e)}
                  onMouseOver={(e) => props.onListItemMouseOver(value, e)}
                  onMouseOut={(e) => props.onListItemMouseOut(value, e)}
                  className={classNames({
                    "highlight-row":
                      props.selectedIds &&
                      props.selectedIds.indexOf(value.key) !== -1,
                  })}
                >
                  {value.title.map((vv, ii) => {
                    return (
                      <td
                        key={ii}
                        className={classNames(
                          {
                            "expanded-row-content": vv.expand,
                            "hide-row": vv.expand && isHidden,
                          },
                          vv.classes
                        )}
                      >
                        {ii === 0 && hasExpand && (
                          <span
                            onClick={(e) => onExpandClick(e, value.key)}
                            style={{
                              cursor: "pointer",
                              marginRight: "4px",
                            }}
                          >
                            <span
                              className={classNames("glyphicon", {
                                "glyphicon-chevron-right": isHidden,
                                "glyphicon-chevron-down": !isHidden,
                              })}
                            ></span>
                          </span>
                        )}
                        {vv.el}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

      {props.legend && !props.selected && (
        <div className="panel-footer">
          <h4 className="panel-footer-title">Legend:</h4>
          {props.legend}
        </div>
      )}
    </div>
  );
}

export default ListBox;